import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["message"]
  static values = { dismissAfter: { type: Number, default: 5000 } }

  connect() {
    this.timeout = setTimeout(() => this.dismissAll(), this.dismissAfterValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  dismiss(event) {
    this.hide(event.target.closest("[data-flash-target='message']"))
  }

  dismissAll() {
    this.messageTargets.forEach((message) => this.hide(message))
  }

  hide(message) {
    if (!message) return

    message.classList.add("opacity-0")
    message.addEventListener("transitionend", () => message.remove(), { once: true })
  }
}
